// Menu - User
import { entryRoutes } from '../../../utility/route-locations';

const userMenuStructure = {
  groups: [{
    name: 'only_one',
    titleId: 'n/a',
    items: [
      {
        name: 'home',
        titleId: 'home',
        path: entryRoutes.dashboard,
      },
      {
        name: 'my-details',
        titleId: 'myDetails',
        path: entryRoutes.myDetails,
      },
      {
        name: 'sign-out',
        titleId: 'signOut',
        path: 'func:sign-out',
      },
    ],
  }],
};

export default userMenuStructure;
